export const LISTINGS_PER_PAGE = 20;
